import React, { useEffect } from "react";
import BackButton from "../../../components/common/BackButton";
import serviceIcon from "../../../assets/icons/serviceIcon.png";
import navigoServices from "../../../services/NavigoServices";
import { useState } from "react";
import { useHistory } from "react-router";
import CommonHeader from "../../../CommonHeader";

export default function NavigoFirstSection6({ handleGotoAddress }) {
  const history = useHistory();
  const [error, setError] = useState(null);
  const [isPB, setIsPB] = useState(false);

  useEffect(() => {
    const source = localStorage.getItem("app_source");
    setIsPB(source === "pb");
  }, []);
  const validationCall = () => {
    const zyPid = localStorage.getItem("zy.pid");
    setError(null);
    navigoServices
      .validateUser(zyPid)
      .then((res) => {
        console.log("API Response:", res.data.slug);
        if (res.data.slug) {
          const redirectUrl = `https://mli.hra.zyla.in/#/hra/${res.data.slug}`;
          //dev3-bridge.zyla.in staging
          // mli.hra.zyla.in prod hraOnBot
          window.location.href = redirectUrl;
        } else {
          console.error("Slug not found in response");
          setError("Something went wrong. Please try again.");
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setError("Something went wrong. Please try again.");
      });
  };

  return (
    <div>
      {isPB && <CommonHeader />}
      {error && <div style={styles.error}>{error}</div>}
      {!error && (
        <div>
          {" "}
          <div>
            <div style={styles.header}>
              {/* <BackButton onClick={() => localHistory.push("/tab/home")} /> */}
              {/* <BackButton
                onClick={() => history.push("/tab/home")}
                style={styles.backButton}
              >
                Back
              </BackButton> */}
              <p style={styles.headerTitle}>Book services</p>
            </div>
            <div style={styles.container}>
              <div style={styles.card}>
                <div style={styles.iconWrapper}>
                  <img
                    src={serviceIcon}
                    alt="Service Icon"
                    style={styles.icon}
                  />
                </div>
                <div style={styles.content}>
                  <h3 style={styles.title}>How Healthy Are You?</h3>
                  <p style={styles.description}>
                    Find out in minutes with a quick Health Risk Assessment.
                    <br /> 1. Identify health concerns
                    <br />
                    2. Get a personalised nutrition & fitness plan
                    <br /> 3. Stay on track with expert support
                  </p>
                  <p style={styles.note}>Start your journey today!</p>
                </div>
              </div>
              <button style={styles.button} onClick={validationCall}>
                Continue
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    padding: "16px",
    backgroundColor: "#f7f7f7",
    height: "100vh",
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: "16px",
  },
  headerTitle: {
    marginLeft: "10px",
    fontSize: "18px",
    fontWeight: "bold",
    color: "#333",
  },
  card: {
    display: "flex",
    alignItems: "flex-start",
    background: "#fff",
    borderRadius: "8px 8px 0px 0px",
    padding: "16px 16px 0px 16px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },
  iconWrapper: {
    flexShrink: 0,
    marginRight: "16px",
  },
  icon: {
    width: "65px",
    height: "90px",
    marginRight: "16px",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontSize: "14px",
    fontWeight: "bold",
    margin: 0,
    color: "#1e1e1e",
  },
  title2: {
    fontSize: "14px",
    fontWeight: "bold",
    margin: 0,
    color: "#1e1e1e",
  },
  description: {
    margin: "8px 0",
    fontSize: "14px",
    lineHeight: "1.5",
  },
  note: {
    fontSize: "14px",
    marginBottom: "16px",
  },
  button: {
    background: "#900c3f",
    color: "#ffffff",
    border: "none",
    padding: "12px 24px",
    borderRadius: "0px 0px 8px 8px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "bold",
    textAlign: "center",
    width: "100%",
    marginTop: "auto",
  },
  error: {
    color: "black",
    fontSize: "14px",
    padding: "100px",
    fontWeight: "bold",
    marginTop: "200px",
  },
};
